// import { computed } from 'vue'
import dayjs from 'dayjs'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
const quarterOfYear = require('dayjs/plugin/quarterOfYear')
dayjs.extend(quarterOfYear)
export default function useTable (selectedWeek) {
  const { t } = useI18n()
  const leftColumns = computed(() => ([
    {
      width: 150,
      title: t('shared.objective'),
      dataIndex: 'objectiveContent',
      fixed: 'left',
      rowSpan: o => (o.objectiveRowIndex === o.objectiveRowsCount - 1 && o.objectiveRowsCount) || ('objectiveRowIndex' in o ? 0 : 1)
    },
    {
      width: 150,
      title: t('shared.keyResult'),
      dataIndex: 'krContent',
      fixed: 'left',
      rowSpan: o => (o.krRowIndex === o.krRowsCount - 1 && o.krRowsCount) || ('krRowIndex' in o ? 0 : 1)
      // rowSpan: o => (o.childKrIndex === o.childKrLength - 1 && o.childKrLength) || ('childKrIndex' in o ? 0 : 1)
    },
    {
      width: 150,
      title: t('weekly.head'),
      dataIndex: 'name',
      fixed: 'left',
      rowSpan: o => (o.childObjectiveRowIndex === o.childObjectiveRowsCount - 1 && o.childObjectiveRowsCount) || ('childObjectiveRowIndex' in o ? 0 : 1)
    },
    {
      width: 150,
      title: t('weekly.item'),
      dataIndex: 'childKrContent',
      fixed: 'left'
    },
    {
      width: 150,
      title: t('weekly.collaborativeUser'),
      dataIndex: 'childKrCollaborativeUsers',
      fixed: 'left'
    },
    {
      width: 150,
      title: t('shared.indicator'),
      dataIndex: 'indicator',
      fixed: 'left'
    },
    {
      width: 110,
      title: t('shared.startDay'),
      dataIndex: 'childKrStartDay',
      fixed: 'left'
    },
    {
      width: 110,
      title: t('shared.finishDay'),
      dataIndex: 'childKrEndDay',
      fixed: 'left'
    },
    {
      width: 90,
      title: t('shared.progress'),
      dataIndex: 'childKrProgress',
      fixed: 'left'
    }
  ]))

  const columns = computed(() => {
    const formatedWeek = selectedWeek.value.format('YYYY-MM-DD')
    const weekColumn = [{
      title: formatedWeek,
      children: [
        {
          width: 150,
          title: t('weekly.progress'),
          dataIndex: `week:${formatedWeek}:currentProgress`
        },
        {
          width: 150,
          title: `${t('weekly.risk')}(${t('weekly.originData')})`,
          dataIndex: `week:${formatedWeek}:currentRisk`
        },
        {
          width: 150,
          title: t('weekly.risk'),
          dataIndex: `week:${formatedWeek}:currentRiskToEdit`
        },
        {
          width: 150,
          title: t('weekly.comments'),
          dataIndex: `week:${formatedWeek}:remarks`
        }
      ]
    }]

    return leftColumns.value.concat(weekColumn)
  })
  return {
    columns
  }
}
